<template>
  <div>
    <div>
      <div class="wthdr-header">
        <div class="logo"></div>
        <div class="title">모든오더 회원탈퇴 안내 </div>
      </div>
      <div class="wthdr-container">
        <!-- <a :href="url" class="link mb24">https://qr.modnpay.kr/menu/modn/mobile/ui/</a> -->
        <div class="link mb24" @click="openApp">https://qr.modnpay.kr/menu/modn/mobile/ui/</div>
        <img class="mb20" src="@/assets/img/img-onnuriorder-quit-01.png">
        <p class="mb40">마이페이지 > 설정 메뉴로 진입후,<br>설정 > 하단의 '탈퇴하기' 를 터치합니다.</p>
        <img class="mb24" src="@/assets/img/img-onnuriorder-quit-02.png">
        <p class="mb32">탈퇴하기 버튼 터치 후,<br>탈퇴 최종 확인 버튼을 터치합니다. </p>
        <p>회원탈퇴를 완료하면 회원의 정보인<br>① 결제내역, ② 결제정보, ③ 주문내역,<br>④알림함 내용 등이 삭제됩니다.</p>
      </div>
    </div>
    <!-- <div v-else>
      <div class="wthdr-error">
        <div class="icon mb20"></div>
        <div class="text mb40"><span>죄송합니다.</span><br>앱으로 접근해주세요.</div>
        <div class="btn" @click="moveStore">스토어 가기</div>
      </div>
    </div> -->
  </div>
</template>
<script lang="js">
export default {
  data () {
    return {
    }
  },
  computed: {
    url () {
      return window.location.origin == 'https://qr.modnpay.kr' ? 'https://qr.modnpay.kr/menu/modn/mobile/ui/appSetting?viewToggle=true' : 'https://dqr.onnuriorder.kr/menu/modn/mobile/ui/appSetting?viewToggle=true'
    }
  },
  methods: {
    openApp () {
      const storeUrl = 'https://play.google.com/store/apps/details?id=info.seeroo.modnorder'

      // 시도: 딥링크로 앱 호출
      const iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      iframe.src = this.url

      document.body.appendChild(iframe)

      // 일정 시간 후 앱이 실행되지 않았으면 스토어로 이동
      setTimeout(() => {
        window.location.href = storeUrl
      }, 2000) // 2초 대기 후 스토어로 이동
    }
  }
}
</script>
<style scoped>
.wthdr-header{
  padding: 60px 40px 40px;
}
.wthdr-header .logo{
  background: url('../assets/img/bi-onnuriorder-quit.png') no-repeat center;
  background-size: contain;
  width: 100%;
  height: 28px;
  margin-bottom: 20px;
}
.wthdr-header .title{
  font-size: 22px;
  font-weight: bold;
  color: #111;
  text-align: center;
}
.wthdr-container{
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f5f5f9;
  padding: 40px 24px;
  text-align: center;
  color: #111;
  line-height: 24px;
  font-size: 16px;
}
.wthdr-container img{
  display: block;
  max-width: 500px;
  width: 100%;
  height: 100%;
}
.wthdr-container .link{
  max-width: 500px;
  text-decoration: underline;
  line-height: 21px;
  font-size: 14px;
}
.wthdr-error{
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.wthdr-error .icon{
  background: url('../assets/img/ic_error_60.png') no-repeat center;
  background-size: contain;
  width: 60px;
  height: 60px;
}
.wthdr-error .text{
  font-size: 22px;
  line-height: 32px;
  font-weight: bold;
  text-align: center;
}
.wthdr-error .text span{
  color: #FF5522;
}
.wthdr-error .btn{
  width: 240px;
  height: 60px;
  background-color: #FF5522;
  color: #fff;
  text-align: center;
  font-weight: bold;
  line-height: 60px;
  font-size: 18px;
}
.mb20{
  margin-bottom: 20px;
}
.mb24{
  margin-bottom: 24px;
}
.mb32{
  margin-bottom: 32px;
}
.mb40{
  margin-bottom: 40px;
}
</style>
